<template>
  <div :class="isOn ? 'kaiGuan1' : 'kaiGuan2'"></div>
</template>

<script>
import { parseDeviceSwitches } from "../../utils/protocol/runtime";

export default {
  name: "DeviceStatusNode",
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    },
    node: {
      type: String,
      required: true
    }
  },
  computed: {
    isOn() {
      return Boolean(parseDeviceSwitches(this.protocol)[this.node]);
    }
  }
};
</script>
